import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { Arrow } from "./Doodles";
import { Sticker, Churro, Cookie, Donut, LegoCar } from "./Stickers";

const stickers = {
  "Loves building": (
    <Sticker testid="sticker-lego-car" className="-top-7 right-2 w-20 h-16" rotate={-8} delay={0.2}><LegoCar /></Sticker>
  ),
  "Favourite snacks": (
    <>
      <Sticker testid="sticker-churro" className="-top-7 right-3 w-14 h-14" rotate={0} delay={0.2}><Churro /></Sticker>
      <Sticker testid="sticker-cookie" className="-bottom-5 right-14 w-11 h-11" rotate={-10} delay={0.35}><Cookie /></Sticker>
      <Sticker testid="sticker-donut" className="-bottom-4 -right-3 w-12 h-12" rotate={8} delay={0.5}><Donut /></Sticker>
    </>
  ),
};

const Photo = ({ src, alt, className, testid, ratio }) => (
  <motion.div
    whileHover={{ scale: 1.03, rotate: 0 }}
    transition={{ type: "spring", stiffness: 200, damping: 18 }}
    className={`overflow-hidden rounded-[1.5rem] border-4 border-cream/90 shadow-2xl ${className}`}
    style={{ aspectRatio: ratio }}
    data-testid={testid}
  >
    <img src={src} alt={alt} className="w-full h-full object-cover" />
  </motion.div>
);

const bits = [
  { t: "From", v: "Rickmansworth, Hertfordshire", c: "bg-butter text-ink" },
  { t: "Loves building", v: "Lego cars", c: "bg-coral text-cream" },
  { t: "Favourite snacks", v: "Churros, cookies & donuts", c: "bg-mint text-ink" },
  { t: "Started writing", v: "Aged 6", c: "bg-cream text-ink" },
];

export const AuthorSection = () => (
  <section id="reuben" className="relative bg-ink text-cream py-28 sm:py-40 overflow-hidden grain">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-12 gap-16 items-center">
      <div className="lg:col-span-6 mx-auto w-full max-w-[440px] grid grid-cols-2 gap-5 items-start">
        <Reveal>
          <Photo src="/img/reuben-smile.jpg" alt="Reuben smiling by the water" ratio="222 / 410" className="-rotate-3" testid="author-photo-smile" />
        </Reveal>
        <Reveal delay={0.15} className="mt-10">
          <Photo src="/img/reuben-book.jpg" alt="Reuben holding his first hand-made book" ratio="212 / 412" className="rotate-3" testid="author-photo-book" />
        </Reveal>
        <Reveal delay={0.3} className="col-span-2 mx-auto w-[70%]">
          <Photo src="/img/reuben-writing.jpg" alt="Reuben writing a story in his notebook" ratio="345 / 370" className="-rotate-2" testid="author-photo-writing" />
        </Reveal>
      </div>
      <div className="lg:col-span-6">
        <Reveal><p className="text-xs sm:text-sm font-bold uppercase tracking-[0.25em] text-mint">Meet the author</p></Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-4 font-display text-butter text-5xl sm:text-6xl lg:text-7xl leading-[0.95]">Hey! I'm Reuben.</h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 text-base sm:text-lg leading-relaxed text-cream/85">
            Reuben Ackerman is a young storyteller who loves making people laugh, and dreaming up wild adventures with
            his toys. He wrote The Party Pet Shop when he was 6 years old.
          </p>
          <p className="mt-4 text-base sm:text-lg leading-relaxed text-cream/85">
            He's a storyteller from Rickmansworth in Hertfordshire, who loves writing about adventures from his
            imagination. When he's not writing, you'll find him building Lego cars or eating Churros.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-3">
            {bits.map((b) => (
              <div key={b.t} className={`group relative rounded-2xl p-5 ${b.c} hover:-rotate-1 transition-transform duration-300`} data-testid={`author-fact-${b.v.split(" ")[0].toLowerCase()}`}>
                {stickers[b.t]}
                <p className="text-xs font-bold uppercase tracking-widest opacity-75">{b.t}</p>
                <p className="mt-1 font-display text-lg sm:text-2xl leading-tight">{b.v}</p>
              </div>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.4}>
          <div className="mt-10 flex items-center gap-4">
            <Arrow className="w-24 text-cream/70" />
            <p className="font-hand text-3xl text-butter">I hope you like my stories!</p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
